// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Proxima Nova:300,300i,400,400i,500,500i,700,700i);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Titillium+Web:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://use.typekit.net/ija5zmr.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.titilliumweb_font {
  font-family: "Titillium Web", sans-serif !important;
}

.text-gray4 {
  color: #707070 !important;
}

.text-gray3 {
  color: #E5E5E5 !important;
}

.border-theme {
  border-color: #ced4da !important;
}

.text-theme {
  color: #36A1F5 !important;
}

.text-blue {
  color: #231c86 !important;
}

.theme-info {
  color: #00C2FF !important;
}

.bg-theme {
  background: #36A1F5 !important;
}

.bg-darkblue {
  background: #212B65 !important;
}

.theme-red {
  color: #ff0000 !important;
}

.theme-purple {
  color: #A300FF !important;
}

.theme-darkblue {
  color: #212B64 !important;
}

.border-darkblue {
  border-color: #212B65 !important;
}

/*----------------------------------------------
    Buttons
-----------------------------------------------*/
.btn-white {
  font-weight: 400;
  color: #000000;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-white:hover, .btn-white:active, .btn-white:focus, .btn-white:not(:disabled):not(.disabled):active:focus, .btn-white:not(:disabled):not(.disabled).active:focus, .btn-white:not(:disabled):not(.disabled):active {
  color: #000000;
  background: #f1f3f5;
  border: 1px solid #f1f3f5;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-white-outline {
  font-weight: 400;
  color: #707070;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid #ced4da;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-white-outline:hover, .btn-white-outline:active, .btn-white-outline:focus, .btn-white-outline:not(:disabled):not(.disabled):active:focus, .btn-white-outline:not(:disabled):not(.disabled).active:focus, .btn-white-outline:not(:disabled):not(.disabled):active {
  color: #707070;
  background: #f1f3f5;
  border: 1px solid #ced4da;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-black {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #000000;
  border: 1px solid #000000;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-black:hover, .btn-black:active, .btn-black:focus, .btn-black:not(:disabled):not(.disabled):active:focus, .btn-black:not(:disabled):not(.disabled).active:focus, .btn-black:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #212529;
  border: 1px solid #212529;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-green {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #00C596;
  border: 1px solid #00C596;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-green:hover, .btn-green:active, .btn-green:focus, .btn-green:not(:disabled):not(.disabled):active:focus, .btn-green:not(:disabled):not(.disabled).active:focus, .btn-green:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #00a780;
  border: 1px solid #00a780;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightgreen {
  font-weight: 400;
  color: #00C596;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: hsla(166, 100%, 39%, 0.11);
  border: 1px solid #00C596;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightgreen:hover, .btn-lightgreen:active, .btn-lightgreen:focus, .btn-lightgreen:not(:disabled):not(.disabled):active:focus, .btn-lightgreen:not(:disabled):not(.disabled).active:focus, .btn-lightgreen:not(:disabled):not(.disabled):active {
  color: #00C596;
  background-color: hsla(166, 100%, 39%, 0.4);
  border: 1px solid #009b77;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-darkblue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: #202B63;
  border: 1px solid #3A4789;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-darkblue:hover, .btn-darkblue:active, .btn-darkblue:focus, .btn-darkblue:not(:disabled):not(.disabled):active:focus, .btn-darkblue:not(:disabled):not(.disabled).active:focus, .btn-darkblue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #1c2658;
  border: 1px solid #303b74;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-darkblue-outline {
  font-weight: 400;
  color: #202B63;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: #ffffff;
  border: 1px solid #3A4789;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-darkblue-outline:hover, .btn-darkblue-outline:active, .btn-darkblue-outline:focus, .btn-darkblue-outline:not(:disabled):not(.disabled):active:focus, .btn-darkblue-outline:not(:disabled):not(.disabled).active:focus, .btn-darkblue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #202B63;
  border: 1px solid #3A4789;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-blue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #077EE6;
  border: 1px solid #077EE6;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-blue:hover, .btn-blue:active, .btn-blue:focus, .btn-blue:not(:disabled):not(.disabled):active:focus, .btn-blue:not(:disabled):not(.disabled).active:focus, .btn-blue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #0172d4;
  border: 1px solid #0172d4;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-blue-outline {
  font-weight: 400;
  color: #077EE6;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #ffffff;
  border: 1px solid #077EE6;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-blue-outline:hover, .btn-blue-outline:active, .btn-blue-outline:focus, .btn-blue-outline:not(:disabled):not(.disabled):active:focus, .btn-blue-outline:not(:disabled):not(.disabled).active:focus, .btn-blue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #077EE6;
  border: 1px solid #077EE6;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightblue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #36A1F5;
  border: 1px solid #36A1F5;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightblue:hover, .btn-lightblue:active, .btn-lightblue:focus, .btn-lightblue:not(:disabled):not(.disabled):active:focus, .btn-lightblue:not(:disabled):not(.disabled).active:focus, .btn-lightblue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #2aa0fa;
  border: 1px solid #2aa0fa;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightblue-outline {
  font-weight: 400;
  color: #36A1F5;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #F2F9FF;
  border: 1px solid #36A1F5;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightblue-outline:hover, .btn-lightblue-outline:active, .btn-lightblue-outline:focus, .btn-lightblue-outline:not(:disabled):not(.disabled):active:focus, .btn-lightblue-outline:not(:disabled):not(.disabled).active:focus, .btn-lightblue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #36A1F5;
  border: 1px solid #36A1F5;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightred {
  font-weight: 400;
  color: #CB3F3F;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #FFEFEF;
  border: 1px solid #FF004E;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightred:hover, .btn-lightred:active, .btn-lightred:focus, .btn-lightred:not(:disabled):not(.disabled):active:focus, .btn-lightred:not(:disabled):not(.disabled).active:focus, .btn-lightred:not(:disabled):not(.disabled):active {
  color: #CB3F3F;
  background-color: #fda3a3;
  border: 1px solid #FF004E;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightOrange {
  font-weight: 400;
  color: #feb019;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #f8efde;
  border: 1px solid #feb019;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightOrange:hover, .btn-lightOrange:active, .btn-lightOrange:focus, .btn-lightOrange:not(:disabled):not(.disabled):active:focus, .btn-lightOrange:not(:disabled):not(.disabled).active:focus, .btn-lightOrange:not(:disabled):not(.disabled):active {
  color: #feb019;
  background-color: #fce9c5;
  border: 1px solid #feb019;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.timeanalysis-nav {
  position: relative;
  background: #EEEEEE;
}
.timeanalysis-nav .header-top {
  position: relative;
  box-shadow: none;
  z-index: 2;
}
.timeanalysis-nav .header-top .navbar-nav {
  align-items: center;
}
.timeanalysis-nav .header-top .navbar-nav .nav-link {
  color: #000000;
}
.timeanalysis-nav .header-top .navbar-nav .profile-img {
  background: rgba(255, 255, 255, 0.1215686275);
  border: 1px solid #DEDEDE;
  border-radius: 21px;
}
.timeanalysis-nav .header-top .navbar-nav .profile-img img {
  width: 35px;
  height: 35px;
}
.timeanalysis-nav .header-top .navbar-nav .profile-img .text .profile-name {
  font-size: 14px;
  line-height: 6px;
}
.timeanalysis-nav .header-top .search .search-bar {
  color: #000000;
  background: rgba(255, 255, 255, 0.3019607843);
  box-shadow: none;
}
.timeanalysis-nav .header-top .student-notification i {
  font-size: 1.5rem;
}
.timeanalysis-nav .header-bottom {
  position: relative;
  z-index: 1;
}
.timeanalysis-nav .header-bottom .title {
  color: #000000;
}
.timeanalysis-nav .header-bottom .subtitle {
  color: #000000;
}
.timeanalysis-nav .header-bottom .card {
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.5019607843);
  border: 1px solid #dbd8d8;
}
.timeanalysis-nav .header-bottom .card img {
  margin-top: -3rem;
  margin-bottom: 10px;
}
.timeanalysis-nav .header-bottom .datePicker .calendar {
  color: #000000;
  position: absolute;
  left: 15px;
  top: 0;
  font-size: 18px;
  background: rgba(255, 255, 255, 0.2274509804);
  padding: 10px;
  border-radius: 4px;
}
.timeanalysis-nav .header-bottom .datePicker .form-control {
  padding-left: 40px;
  border: 1px solid #dbd8d8;
  background-color: rgba(255, 255, 255, 0.5019607843);
  color: #000000;
}
.timeanalysis-nav .header-bottom .datePicker .form-control::placeholder {
  color: #000000;
}
.timeanalysis-nav .header-bottom .datePicker .rdtPicker {
  right: 0;
}

.time-analysis .css-2b097c-container {
  position: relative;
  z-index: 1;
}
.time-analysis .filter button {
  padding: 0.45rem 1rem;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1019607843);
}
.time-analysis .time-error {
  border-radius: 6px !important;
  overflow: hidden;
}
.time-analysis .time-complexity {
  border-radius: 6px !important;
  background: #EEEEEE;
}
.time-analysis .time-complexity .card-header {
  border-radius: 6px !important;
}
.time-analysis .time-complexity .card-body {
  background: #EEEEEE;
}
.time-analysis .time-complexity .card-body .complexity-question {
  position: relative;
  margin-top: 5px;
  border-radius: 6px !important;
}
.time-analysis .time-complexity .card-body .complexity-question .react-bootstrap-table,
.time-analysis .time-complexity .card-body .complexity-question .table {
  border: none !important;
}
.time-analysis .time-complexity .card-body .complexity-question .react-bootstrap-table th,
.time-analysis .time-complexity .card-body .complexity-question .react-bootstrap-table td,
.time-analysis .time-complexity .card-body .complexity-question .table th,
.time-analysis .time-complexity .card-body .complexity-question .table td {
  padding: 0.9rem 0.45rem;
  outline: none;
}
.time-analysis .time-complexity .card-body .complexity-question .react-bootstrap-table thead,
.time-analysis .time-complexity .card-body .complexity-question .table thead {
  background-color: #ffffff;
  border-bottom: 1px solid #dee2e6;
}
.time-analysis .time-complexity .card-body .complexity-question .react-bootstrap-table thead th,
.time-analysis .time-complexity .card-body .complexity-question .table thead th {
  border-right: 1px solid #dee2e6;
}
.time-analysis .time-complexity .card-body .complexity-question .react-bootstrap-table thead th:nth-child(2n),
.time-analysis .time-complexity .card-body .complexity-question .table thead th:nth-child(2n) {
  border-right: 1px solid #dee2e6;
}
.time-analysis .time-complexity .card-body .complexity-question .react-bootstrap-table thead th:last-child, .time-analysis .time-complexity .card-body .complexity-question .react-bootstrap-table thead th:nth-child(2), .time-analysis .time-complexity .card-body .complexity-question .react-bootstrap-table thead th:nth-child(4), .time-analysis .time-complexity .card-body .complexity-question .react-bootstrap-table thead th:nth-child(6),
.time-analysis .time-complexity .card-body .complexity-question .table thead th:last-child,
.time-analysis .time-complexity .card-body .complexity-question .table thead th:nth-child(2),
.time-analysis .time-complexity .card-body .complexity-question .table thead th:nth-child(4),
.time-analysis .time-complexity .card-body .complexity-question .table thead th:nth-child(6) {
  border-right: 0;
}
.time-analysis .time-complexity .card-body .complexity-question .react-bootstrap-table tbody td,
.time-analysis .time-complexity .card-body .complexity-question .table tbody td {
  border-right: 1px solid #dee2e6;
}
.time-analysis .time-complexity .card-body .complexity-question .react-bootstrap-table tbody td:last-child, .time-analysis .time-complexity .card-body .complexity-question .react-bootstrap-table tbody td:nth-child(2), .time-analysis .time-complexity .card-body .complexity-question .react-bootstrap-table tbody td:nth-child(4), .time-analysis .time-complexity .card-body .complexity-question .react-bootstrap-table tbody td:nth-child(6),
.time-analysis .time-complexity .card-body .complexity-question .table tbody td:last-child,
.time-analysis .time-complexity .card-body .complexity-question .table tbody td:nth-child(2),
.time-analysis .time-complexity .card-body .complexity-question .table tbody td:nth-child(4),
.time-analysis .time-complexity .card-body .complexity-question .table tbody td:nth-child(6) {
  font-weight: 600 !important;
  border-right: 0;
}
.time-analysis .time-complexity .card-body .complexity-question .react-bootstrap-table tbody td:nth-child(3), .time-analysis .time-complexity .card-body .complexity-question .react-bootstrap-table tbody td:nth-child(5), .time-analysis .time-complexity .card-body .complexity-question .react-bootstrap-table tbody td:nth-child(7),
.time-analysis .time-complexity .card-body .complexity-question .table tbody td:nth-child(3),
.time-analysis .time-complexity .card-body .complexity-question .table tbody td:nth-child(5),
.time-analysis .time-complexity .card-body .complexity-question .table tbody td:nth-child(7) {
  font-weight: 400 !important;
  color: #F05D70;
}
.time-analysis .time-question-type {
  overflow: hidden;
  border-radius: 6px !important;
}
.time-analysis .time-question-type .card-body .react-bootstrap-table,
.time-analysis .time-question-type .card-body .table {
  border: none !important;
}
.time-analysis .time-question-type .card-body .react-bootstrap-table th,
.time-analysis .time-question-type .card-body .react-bootstrap-table td,
.time-analysis .time-question-type .card-body .table th,
.time-analysis .time-question-type .card-body .table td {
  padding: 0.95rem 0.45rem;
  outline: none;
}
.time-analysis .time-question-type .card-body .react-bootstrap-table thead,
.time-analysis .time-question-type .card-body .table thead {
  background-color: #ffffff;
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
}
.time-analysis .time-question-type .card-body .react-bootstrap-table thead th,
.time-analysis .time-question-type .card-body .table thead th {
  border-right: 1px solid #dee2e6;
}
.time-analysis .time-question-type .card-body .react-bootstrap-table thead th:nth-child(2n),
.time-analysis .time-question-type .card-body .table thead th:nth-child(2n) {
  border-right: 1px solid #dee2e6;
}
.time-analysis .time-question-type .card-body .react-bootstrap-table thead th:last-child, .time-analysis .time-question-type .card-body .react-bootstrap-table thead th:nth-child(2), .time-analysis .time-question-type .card-body .react-bootstrap-table thead th:nth-child(4), .time-analysis .time-question-type .card-body .react-bootstrap-table thead th:nth-child(6),
.time-analysis .time-question-type .card-body .table thead th:last-child,
.time-analysis .time-question-type .card-body .table thead th:nth-child(2),
.time-analysis .time-question-type .card-body .table thead th:nth-child(4),
.time-analysis .time-question-type .card-body .table thead th:nth-child(6) {
  border-right: 0;
}
.time-analysis .time-question-type .card-body .react-bootstrap-table tbody td,
.time-analysis .time-question-type .card-body .table tbody td {
  border-right: 1px solid #dee2e6;
}
.time-analysis .time-question-type .card-body .react-bootstrap-table tbody td:last-child, .time-analysis .time-question-type .card-body .react-bootstrap-table tbody td:nth-child(2), .time-analysis .time-question-type .card-body .react-bootstrap-table tbody td:nth-child(4), .time-analysis .time-question-type .card-body .react-bootstrap-table tbody td:nth-child(6),
.time-analysis .time-question-type .card-body .table tbody td:last-child,
.time-analysis .time-question-type .card-body .table tbody td:nth-child(2),
.time-analysis .time-question-type .card-body .table tbody td:nth-child(4),
.time-analysis .time-question-type .card-body .table tbody td:nth-child(6) {
  font-weight: 600 !important;
  border-right: 0;
}
.time-analysis .time-question-type .card-body .react-bootstrap-table tbody td:nth-child(3), .time-analysis .time-question-type .card-body .react-bootstrap-table tbody td:nth-child(5), .time-analysis .time-question-type .card-body .react-bootstrap-table tbody td:nth-child(7),
.time-analysis .time-question-type .card-body .table tbody td:nth-child(3),
.time-analysis .time-question-type .card-body .table tbody td:nth-child(5),
.time-analysis .time-question-type .card-body .table tbody td:nth-child(7) {
  font-weight: 400 !important;
  color: #F05D70;
}
.time-analysis .time-subject {
  border-radius: 6px !important;
}
.time-analysis .time-subject .card-header {
  overflow: hidden;
  z-index: 1;
  border-radius: 6px !important;
  margin-bottom: -5px;
  border-bottom: 0;
}
.time-analysis .time-subject .card-body {
  background: #EEEEEE;
}
.time-analysis .time-subject .card-body .complexity-question {
  position: relative;
  margin-top: 5px;
  border-radius: 6px !important;
}
.time-analysis .time-subject .card-body .complexity-question .react-bootstrap-table,
.time-analysis .time-subject .card-body .complexity-question .table {
  border: none !important;
}
.time-analysis .time-subject .card-body .complexity-question .react-bootstrap-table th,
.time-analysis .time-subject .card-body .complexity-question .react-bootstrap-table td,
.time-analysis .time-subject .card-body .complexity-question .table th,
.time-analysis .time-subject .card-body .complexity-question .table td {
  padding: 0.9rem 0.45rem;
  outline: none;
}
.time-analysis .time-subject .card-body .complexity-question .react-bootstrap-table thead,
.time-analysis .time-subject .card-body .complexity-question .table thead {
  background-color: #ffffff;
  border-bottom: 1px solid #dee2e6;
}
.time-analysis .time-subject .card-body .complexity-question .react-bootstrap-table thead th,
.time-analysis .time-subject .card-body .complexity-question .table thead th {
  border-right: 1px solid #dee2e6;
}
.time-analysis .time-subject .card-body .complexity-question .react-bootstrap-table thead th:nth-child(2n),
.time-analysis .time-subject .card-body .complexity-question .table thead th:nth-child(2n) {
  border-right: 1px solid #dee2e6;
}
.time-analysis .time-subject .card-body .complexity-question .react-bootstrap-table thead th:last-child, .time-analysis .time-subject .card-body .complexity-question .react-bootstrap-table thead th:nth-child(2), .time-analysis .time-subject .card-body .complexity-question .react-bootstrap-table thead th:nth-child(4), .time-analysis .time-subject .card-body .complexity-question .react-bootstrap-table thead th:nth-child(6),
.time-analysis .time-subject .card-body .complexity-question .table thead th:last-child,
.time-analysis .time-subject .card-body .complexity-question .table thead th:nth-child(2),
.time-analysis .time-subject .card-body .complexity-question .table thead th:nth-child(4),
.time-analysis .time-subject .card-body .complexity-question .table thead th:nth-child(6) {
  border-right: 0;
}
.time-analysis .time-subject .card-body .complexity-question .react-bootstrap-table tbody td,
.time-analysis .time-subject .card-body .complexity-question .table tbody td {
  border-right: 1px solid #dee2e6;
}
.time-analysis .time-subject .card-body .complexity-question .react-bootstrap-table tbody td:last-child, .time-analysis .time-subject .card-body .complexity-question .react-bootstrap-table tbody td:nth-child(2), .time-analysis .time-subject .card-body .complexity-question .react-bootstrap-table tbody td:nth-child(4), .time-analysis .time-subject .card-body .complexity-question .react-bootstrap-table tbody td:nth-child(6),
.time-analysis .time-subject .card-body .complexity-question .table tbody td:last-child,
.time-analysis .time-subject .card-body .complexity-question .table tbody td:nth-child(2),
.time-analysis .time-subject .card-body .complexity-question .table tbody td:nth-child(4),
.time-analysis .time-subject .card-body .complexity-question .table tbody td:nth-child(6) {
  font-weight: 600 !important;
  border-right: 0;
}
.time-analysis .time-subject .card-body .complexity-question .react-bootstrap-table tbody td:nth-child(3), .time-analysis .time-subject .card-body .complexity-question .react-bootstrap-table tbody td:nth-child(5), .time-analysis .time-subject .card-body .complexity-question .react-bootstrap-table tbody td:nth-child(7),
.time-analysis .time-subject .card-body .complexity-question .table tbody td:nth-child(3),
.time-analysis .time-subject .card-body .complexity-question .table tbody td:nth-child(5),
.time-analysis .time-subject .card-body .complexity-question .table tbody td:nth-child(7) {
  font-weight: 400 !important;
  color: #F05D70;
}`, "",{"version":3,"sources":["webpack://./src/_config.scss","webpack://./src/neetjee_guru/components/analysis/time_analysis/_timeanalysis.scss"],"names":[],"mappings":"AAkCA;EACI,mDAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,gCAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,8BAAA;AC9BJ;;ADiCA;EACI,8BAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,gCAAA;AC9BJ;;ADkCA;;gDAAA;AAIA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AChCJ;ADkCI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACrCR;;ADyCA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACtCJ;ADwCI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;AC3CR;;AD+CA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC5CJ;AD8CI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACjDR;;ADqDA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AClDJ;ADoDI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACvDR;;AD2DA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,4CAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACxDJ;AD0DI;EAMI,cAAA;EACA,2CAAA;EACA,yBAAA;EACA,iDAAA;AC7DR;;ADiEA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC9DJ;ADgEI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACnER;;ADuEA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACpEJ;ADsEI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACzER;;AD6EA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC1EJ;AD4EI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC/ER;;ADoFA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACjFJ;ADmFI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACtFR;;AD0FA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACvFJ;ADyFI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC5FR;;AD+FA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC5FJ;AD8FI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACjGR;;ADqGA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AClGJ;ADqGI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACxGR;;AD4GA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACzGJ;AD2GI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC9GR;;AA9WA;EACI,kBAAA;EACA,mBAAA;AAiXJ;AA/WI;EACI,kBAAA;EACA,gBAAA;EACA,UAAA;AAiXR;AA/WQ;EACI,mBAAA;AAiXZ;AA/WY;EACI,cAAA;AAiXhB;AA9WY;EACI,6CAAA;EACA,yBAAA;EACA,mBAAA;AAgXhB;AA9WgB;EACI,WAAA;EACA,YAAA;AAgXpB;AA5WoB;EACI,eAAA;EACA,gBAAA;AA8WxB;AAxWQ;EACI,cAAA;EACA,6CAAA;EACA,gBAAA;AA0WZ;AAvWQ;EACI,iBAAA;AAyWZ;AArWI;EACI,kBAAA;EACA,UAAA;AAuWR;AArWQ;EACI,cAAA;AAuWZ;AApWQ;EACI,cAAA;AAsWZ;AAnWQ;EACI,mBAAA;EACA,mDAAA;EACA,yBAAA;AAqWZ;AAnWY;EACI,iBAAA;EACA,mBAAA;AAqWhB;AAhWY;EACI,cAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,eAAA;EACA,6CAAA;EACA,aAAA;EACA,kBAAA;AAkWhB;AA/VY;EACI,kBAAA;EACA,yBAAA;EACA,mDAAA;EACA,cAAA;AAiWhB;AA/VgB;EACI,cAAA;AAiWpB;AA7VY;EACI,QAAA;AA+VhB;;AAvVI;EACI,kBAAA;EACA,UAAA;AA0VR;AAtVQ;EACI,qBAAA;EACA,oDAAA;AAwVZ;AApVI;EACI,6BAAA;EACA,gBAAA;AAsVR;AAnVI;EACI,6BAAA;EACA,mBAAA;AAqVR;AAnVQ;EACI,6BAAA;AAqVZ;AAlVQ;EACI,mBAAA;AAoVZ;AAlVY;EACI,kBAAA;EACA,eAAA;EACA,6BAAA;AAoVhB;AAlVgB;;EAEI,uBAAA;AAoVpB;AAlVoB;;;;EAEI,uBAAA;EACA,aAAA;AAsVxB;AAnVoB;;EACI,yBAAA;EACA,gCAAA;AAsVxB;AApVwB;;EACI,+BAAA;AAuV5B;AArV4B;;EACI,+BAAA;AAwVhC;AArV4B;;;;;EAII,eAAA;AAwVhC;AAlVwB;;EACI,+BAAA;AAqV5B;AAnV4B;;;;;EAII,2BAAA;EACA,eAAA;AAsVhC;AAnV4B;;;;EAGI,2BAAA;EACA,cAAA;AAsVhC;AA7UI;EACI,gBAAA;EACA,6BAAA;AA+UR;AA3UY;;EAEI,uBAAA;AA6UhB;AA3UgB;;;;EAEI,wBAAA;EACA,aAAA;AA+UpB;AA5UgB;;EACI,yBAAA;EACA,6BAAA;EACA,gCAAA;AA+UpB;AA7UoB;;EACI,+BAAA;AAgVxB;AA9UwB;;EACI,+BAAA;AAiV5B;AA9UwB;;;;;EAII,eAAA;AAiV5B;AA3UoB;;EACI,+BAAA;AA8UxB;AA5UwB;;;;;EAII,2BAAA;EACA,eAAA;AA+U5B;AA5UwB;;;;EAGI,2BAAA;EACA,cAAA;AA+U5B;AAvUI;EACI,6BAAA;AAyUR;AAvUQ;EACI,gBAAA;EACA,UAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;AAyUZ;AAtUQ;EACI,mBAAA;AAwUZ;AAtUY;EACI,kBAAA;EACA,eAAA;EACA,6BAAA;AAwUhB;AAtUgB;;EAEI,uBAAA;AAwUpB;AAtUoB;;;;EAEI,uBAAA;EACA,aAAA;AA0UxB;AAvUoB;;EACI,yBAAA;EACA,gCAAA;AA0UxB;AAxUwB;;EACI,+BAAA;AA2U5B;AAzU4B;;EACI,+BAAA;AA4UhC;AAzU4B;;;;;EAII,eAAA;AA4UhC;AAtUwB;;EACI,+BAAA;AAyU5B;AAvU4B;;;;;EAII,2BAAA;EACA,eAAA;AA0UhC;AAvU4B;;;;EAGI,2BAAA;EACA,cAAA;AA0UhC","sourcesContent":["// @import url('https://fonts.googleapis.com/css?family=Ubuntu:300,300i,400,400i,500,500i,700,700i&display=swap');\n@import url('https://fonts.googleapis.com/css?family=Proxima%20Nova:300,300i,400,400i,500,500i,700,700i');\n@import url('https://fonts.googleapis.com/css2?family=Titillium+Web:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700&display=swap');\n@import url(\"https://use.typekit.net/ija5zmr.css\");\n\n$theme1: #36A1F5;\n$theme2: #1B2430;\n$white: #ffffff;\n$gray: #ced4da;\n$gray-2: #F2F2F2;\n$gray-3: #E5E5E5;\n$gray-4: #707070;\n$gray-5: #969DAA;\n$green: #01b306;\n$blue: #231c86;\n// #e7e9ea\n$one: #52B8FA;\n$two: #FAEF52;\n$three: #FABC52;\n$four: #AC52FA;\n$five: #FA52C2;\n$six: #FA5252;\n\n// $font-family: 'Ubuntu', sans-serif !important;\n$font-family: 'proxima-nova',\nsans-serif !important;\n\n@mixin fonts ($fontWeight, $fontSize, $lineHeight) {\n    font-family: $font-family;\n    font-size: $fontSize !important;\n    font-weight: $fontWeight !important;\n    line-height: $lineHeight;\n}\n\n.titilliumweb_font {\n    font-family: 'Titillium Web', sans-serif !important;\n}\n\n.text-gray4 {\n    color: $gray-4 !important;\n}\n\n.text-gray3 {\n    color: $gray-3 !important;\n}\n\n.border-theme {\n    border-color: $gray !important;\n}\n\n.text-theme {\n    color: $theme1 !important;\n}\n\n.text-blue {\n    color: $blue !important;\n}\n\n.theme-info {\n    color: #00C2FF !important;\n}\n\n.bg-theme {\n    background: $theme1 !important;\n}\n\n.bg-darkblue {\n    background: #212B65 !important;\n}\n\n.theme-red {\n    color: #ff0000 !important;\n}\n\n.theme-purple {\n    color: #A300FF !important;\n}\n\n.theme-darkblue {\n    color: #212B64 !important;\n}\n\n.border-darkblue {\n    border-color: #212B65 !important;\n}\n\n\n/*----------------------------------------------\n    Buttons\n-----------------------------------------------*/\n\n.btn-white {\n    font-weight: 400;\n    color: #000000;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #ffffff;\n    border: 1px solid #ffffff;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #000000;\n        background: #f1f3f5;\n        border: 1px solid #f1f3f5;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-white-outline {\n    font-weight: 400;\n    color: #707070;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: transparent;\n    border: 1px solid #ced4da;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #707070;\n        background: #f1f3f5;\n        border: 1px solid #ced4da;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-black {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #000000;\n    border: 1px solid #000000;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #212529;\n        border: 1px solid #212529;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-green {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #00C596;\n    border: 1px solid #00C596;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #00a780;\n        border: 1px solid #00a780;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightgreen {\n    font-weight: 400;\n    color: #00C596;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: hsla(166, 100%, 39%, 0.11);\n    border: 1px solid #00C596;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #00C596;\n        background-color: hsla(166, 100%, 39%, 0.4);\n        border: 1px solid #009b77;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-darkblue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background: #202B63;\n    border: 1px solid #3A4789;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #1c2658;\n        border: 1px solid #303b74;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-darkblue-outline {\n    font-weight: 400;\n    color: #202B63;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background: #ffffff;\n    border: 1px solid #3A4789;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #202B63;\n        border: 1px solid #3A4789;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-blue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #077EE6;\n    border: 1px solid #077EE6;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #0172d4;\n        border: 1px solid #0172d4;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n\n.btn-blue-outline {\n    font-weight: 400;\n    color: #077EE6;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #ffffff;\n    border: 1px solid #077EE6;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #077EE6;\n        border: 1px solid #077EE6;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightblue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #36A1F5;\n    border: 1px solid #36A1F5;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #2aa0fa;\n        border: 1px solid #2aa0fa;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n.btn-lightblue-outline {\n    font-weight: 400;\n    color: #36A1F5;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #F2F9FF;\n    border: 1px solid #36A1F5;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #36A1F5;\n        border: 1px solid #36A1F5;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightred {\n    font-weight: 400;\n    color: #CB3F3F;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #FFEFEF;\n    border: 1px solid #FF004E;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #CB3F3F;\n        background-color: #fda3a3;\n        border: 1px solid #FF004E;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightOrange {\n    font-weight: 400;\n    color: #feb019;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #f8efde;\n    border: 1px solid #feb019;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #feb019;\n        background-color: #fce9c5;\n        border: 1px solid #feb019;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}","@import '../../../../_config.scss';\n\n.timeanalysis-nav {\n    position: relative;\n    background: #EEEEEE;\n\n    .header-top {\n        position: relative;\n        box-shadow: none;\n        z-index: 2;\n\n        .navbar-nav {\n            align-items: center;\n\n            .nav-link {\n                color: #000000;\n            }\n\n            .profile-img {\n                background: #ffffff1f;\n                border: 1px solid #DEDEDE;\n                border-radius: 21px;\n\n                img {\n                    width: 35px;\n                    height: 35px;\n                }\n\n                .text {\n                    .profile-name {\n                        font-size: 14px;\n                        line-height: 6px;\n                    }\n                }\n            }\n        }\n\n        .search .search-bar {\n            color: #000000;\n            background: #ffffff4d;\n            box-shadow: none;\n        }\n\n        .student-notification i {\n            font-size: 1.5rem;\n        }\n    }\n\n    .header-bottom {\n        position: relative;\n        z-index: 1;\n\n        .title {\n            color: #000000;\n        }\n\n        .subtitle {\n            color: #000000;\n        }\n\n        .card {\n            border-radius: 10px;\n            background-color: #ffffff80;\n            border: 1px solid #dbd8d8;\n\n            img {\n                margin-top: -3rem;\n                margin-bottom: 10px;\n            }\n        }\n\n        .datePicker {\n            .calendar {\n                color: #000000;\n                position: absolute;\n                left: 15px;\n                top: 0;\n                font-size: 18px;\n                background: #ffffff3a;\n                padding: 10px;\n                border-radius: 4px;\n            }\n\n            .form-control {\n                padding-left: 40px;\n                border: 1px solid #dbd8d8;\n                background-color: #ffffff80;\n                color: #000000;\n\n                &::placeholder {\n                    color: #000000;\n                }\n            }\n\n            .rdtPicker {\n                right: 0;\n            }\n        }\n    }\n}\n\n.time-analysis {\n   \n    .css-2b097c-container {\n        position: relative;\n        z-index: 1;\n       \n    }\n    .filter {\n        button {\n            padding: 0.45rem 1rem;\n            box-shadow: 0px 0px 10px #0000001A;\n        }\n    }\n\n    .time-error {\n        border-radius: 6px !important;\n        overflow: hidden;\n    }\n\n    .time-complexity {\n        border-radius: 6px !important;\n        background: #EEEEEE;\n\n        .card-header {\n            border-radius: 6px !important;\n        }\n\n        .card-body {\n            background: #EEEEEE;\n\n            .complexity-question {\n                position: relative;\n                margin-top: 5px;\n                border-radius: 6px !important;\n\n                .react-bootstrap-table,\n                .table {\n                    border: none !important;\n\n                    th,\n                    td {\n                        padding: 0.9rem 0.45rem;\n                        outline: none;\n                    }\n\n                    thead {\n                        background-color: #ffffff;\n                        border-bottom: 1px solid #dee2e6;\n\n                        th {\n                            border-right: 1px solid #dee2e6;\n\n                            &:nth-child(2n) {\n                                border-right: 1px solid #dee2e6;\n                            }\n\n                            &:last-child,\n                            &:nth-child(2),\n                            &:nth-child(4),\n                            &:nth-child(6) {\n                                border-right: 0;\n                            }\n                        }\n                    }\n\n                    tbody {\n                        td {\n                            border-right: 1px solid #dee2e6;\n\n                            &:last-child,\n                            &:nth-child(2),\n                            &:nth-child(4),\n                            &:nth-child(6) {\n                                font-weight: 600 !important;\n                                border-right: 0;\n                            }\n\n                            &:nth-child(3),\n                            &:nth-child(5),\n                            &:nth-child(7) {\n                                font-weight: 400 !important;\n                                color: #F05D70;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .time-question-type {\n        overflow: hidden;\n        border-radius: 6px !important;\n\n        .card-body {\n\n            .react-bootstrap-table,\n            .table {\n                border: none !important;\n\n                th,\n                td {\n                    padding: 0.95rem 0.45rem;\n                    outline: none;\n                }\n\n                thead {\n                    background-color: #ffffff;\n                    border-top: 1px solid #dee2e6;\n                    border-bottom: 1px solid #dee2e6;\n\n                    th {\n                        border-right: 1px solid #dee2e6;\n\n                        &:nth-child(2n) {\n                            border-right: 1px solid #dee2e6;\n                        }\n\n                        &:last-child,\n                        &:nth-child(2),\n                        &:nth-child(4),\n                        &:nth-child(6) {\n                            border-right: 0;\n                        }\n                    }\n                }\n\n                tbody {\n                    td {\n                        border-right: 1px solid #dee2e6;\n\n                        &:last-child,\n                        &:nth-child(2),\n                        &:nth-child(4),\n                        &:nth-child(6) {\n                            font-weight: 600 !important;\n                            border-right: 0;\n                        }\n\n                        &:nth-child(3),\n                        &:nth-child(5),\n                        &:nth-child(7) {\n                            font-weight: 400 !important;\n                            color: #F05D70;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .time-subject {\n        border-radius: 6px !important;\n\n        .card-header {\n            overflow: hidden;\n            z-index: 1;\n            border-radius: 6px !important;\n            margin-bottom: -5px;\n            border-bottom: 0;\n        }\n\n        .card-body {\n            background: #EEEEEE;\n\n            .complexity-question {\n                position: relative;\n                margin-top: 5px;\n                border-radius: 6px !important;\n\n                .react-bootstrap-table,\n                .table {\n                    border: none !important;\n\n                    th,\n                    td {\n                        padding: 0.9rem 0.45rem;\n                        outline: none;\n                    }\n\n                    thead {\n                        background-color: #ffffff;\n                        border-bottom: 1px solid #dee2e6;\n\n                        th {\n                            border-right: 1px solid #dee2e6;\n\n                            &:nth-child(2n) {\n                                border-right: 1px solid #dee2e6;\n                            }\n\n                            &:last-child,\n                            &:nth-child(2),\n                            &:nth-child(4),\n                            &:nth-child(6) {\n                                border-right: 0;\n                            }\n                        }\n                    }\n\n                    tbody {\n                        td {\n                            border-right: 1px solid #dee2e6;\n\n                            &:last-child,\n                            &:nth-child(2),\n                            &:nth-child(4),\n                            &:nth-child(6) {\n                                font-weight: 600 !important;\n                                border-right: 0;\n                            }\n\n                            &:nth-child(3),\n                            &:nth-child(5),\n                            &:nth-child(7) {\n                                font-weight: 400 !important;\n                                color: #F05D70;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
